import { render, staticRenderFns } from "./TokenWithdrawalConfirmFromEmail.vue?vue&type=template&id=83be2684&"
import script from "./TokenWithdrawalConfirmFromEmail.vue?vue&type=script&lang=js&"
export * from "./TokenWithdrawalConfirmFromEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports